var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.405 17.0208V15.2L14.5812 15.3979C15.8931 15.6354 17.1145 14.8042 17.205 13.6562L17.4764 11.0833L18.7883 10.6083C19.2407 10.45 19.4217 9.975 19.1502 9.57917L17.4764 7.125C17.205 4.11667 15.2598 1.1875 10.2383 1.1875C5.08119 1.1875 2.54785 4.5125 2.54785 7.91667C2.54785 9.38125 3.13595 10.6479 4.04071 11.7167C4.85499 12.7062 5.26214 13.8937 5.26214 15.0812V16.9812H13.405V17.0208Z",
    fill: "#FFB74D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4049 17.021V15.2002L10.2383 14.646V17.021H13.4049Z",
    fill: "#FF9800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4405 9.104C15.8153 9.104 16.1191 8.83817 16.1191 8.51025C16.1191 8.18233 15.8153 7.9165 15.4405 7.9165C15.0658 7.9165 14.762 8.18233 14.762 8.51025C14.762 8.83817 15.0658 9.104 15.4405 9.104Z",
    fill: "#784719"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9669 1.1875C5.85023 1.1875 2.54785 4.07708 2.54785 7.67917C2.54785 12.0729 5.26214 12.1917 5.26214 15.0417L6.43833 14.6854C7.38833 14.4083 8.20261 13.775 8.56452 12.9438L9.83118 10.2521L12.5002 9.10417V6.72917C12.5002 6.72917 15.6669 5.225 15.6669 2.65208C14.3098 1.6625 11.9121 1.1875 9.9669 1.1875Z",
    fill: "#FF5722"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78588 0.831055C9.51445 0.831055 9.3335 0.989388 9.3335 1.22689V6.72897C9.3335 6.96647 9.51445 7.1248 9.78588 7.1248C10.0573 7.1248 10.2383 6.96647 10.2383 6.72897V1.22689C10.2383 0.989388 10.0573 0.831055 9.78588 0.831055ZM16.9787 12.6269C13.4049 12.6269 12.3192 10.6873 12.274 10.6081C12.1835 10.4102 11.9121 10.3311 11.6859 10.4102C11.4597 10.4894 11.3692 10.7269 11.4597 10.9248C11.5049 11.0436 12.8168 13.4186 16.9787 13.4186C17.2502 13.4186 17.4311 13.2602 17.4311 13.0227C17.4311 12.7852 17.2049 12.6269 16.9787 12.6269Z",
    fill: "#546E7A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0239 13.8543C17.5236 13.8543 17.9287 13.4999 17.9287 13.0627C17.9287 12.6254 17.5236 12.271 17.0239 12.271C16.5242 12.271 16.1191 12.6254 16.1191 13.0627C16.1191 13.4999 16.5242 13.8543 17.0239 13.8543Z",
    fill: "#37474F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78581 11.8752C11.5347 11.8752 12.9525 10.6346 12.9525 9.10433C12.9525 7.57404 11.5347 6.3335 9.78581 6.3335C8.03691 6.3335 6.61914 7.57404 6.61914 9.10433C6.61914 10.6346 8.03691 11.8752 9.78581 11.8752Z",
    fill: "#37474F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78584 10.6877C10.7852 10.6877 11.5954 9.97878 11.5954 9.10433C11.5954 8.22988 10.7852 7.521 9.78584 7.521C8.78647 7.521 7.97632 8.22988 7.97632 9.10433C7.97632 9.97878 8.78647 10.6877 9.78584 10.6877Z",
    fill: "#546E7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/IconSupport.3969caf95ce9352cce9b5477302bf19e.svg";
export { ForwardRef as ReactComponent };